// extracted by mini-css-extract-plugin
export var blockedMessage = "_bl-3";
export var blockedOverlay = "_bl-1";
export var fadeIn = "_bl-2";
export var hereLink = "_bl-0";
export var slideUp = "_bl-4";